import { render, staticRenderFns } from "./MMP_CollapsedCoordinates.vue?vue&type=template&id=14c84954&scoped=true&"
import script from "./MMP_CollapsedCoordinates.vue?vue&type=script&lang=js&"
export * from "./MMP_CollapsedCoordinates.vue?vue&type=script&lang=js&"
import style0 from "./MMP_CollapsedCoordinates.vue?vue&type=style&index=0&id=14c84954&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c84954",
  null
  
)

export default component.exports